module.exports = __webpack_public_path__ + "dist/images/f415aab660cf21fd9e5188c3e28c7122.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/select-role/english-leader.svg
// module id = 471
// module chunks = 0